import { gql, useQuery } from '@apollo/client'

import { useAuth } from '@features/auth'

type GetBarcodeData = {
  getBarcode: {
    code: string
    type: string
  }
}

export const GQL_QUERY_GET_BARCODE = gql`
  query getBarcode {
    getBarcode {
      code
      type
    }
  }
`

export const useGetBarcode = () => {
  const { isAuthorized, requireRegistration } = useAuth()
  
  const { data, loading, error, refetch } = useQuery<GetBarcodeData>(
    GQL_QUERY_GET_BARCODE,
    {
      fetchPolicy: 'network-only',
      skip: !isAuthorized || requireRegistration
    }
  )

  return {
    barcode: data?.getBarcode?.code,
    type: data?.getBarcode?.type,
    data,
    loading,
    error,
    refetch
  }
}
